import React from "react";
import { AxiosError } from "axios";
import { IBadRequestValidationFailedModel } from "@models/dto/Rocketta/LicenseServer/Models/IBadRequestValidationFailedModel";
import { IResponseModel } from "@models/dto/Rocketta/LicenseServer/Models/IResponseModel";
import { MessageBar, MessageBarType } from "@fluentui/react";

function isDataPropAxiosErrorMessage(error: any): error is AxiosError {
  return typeof (error as AxiosError).response?.data === "string";
}

function isTitlePropAxiosErrorMessage(error: any): error is AxiosError<{ title: string }> {
  const titleError = (error as AxiosError<{ title: string }>).response?.data.title;
  return !!titleError;
}

export const extractErrorMessage = (error: unknown): string => {
  if (typeof error === "string") {
    return error;
  }
  if (isDataPropAxiosErrorMessage(error) && error.response?.status && error.response?.status >= 500) {
    return "Something went wrong";
  }
  if (isDataPropAxiosErrorMessage(error)) {
    return error.response?.data as string;
  }
  if (isTitlePropAxiosErrorMessage(error)) {
    return (error as AxiosError<{ title: string }>).response?.data.title;
  }

  const errorResponse = error as AxiosError<IBadRequestValidationFailedModel>;
  const errorData = errorResponse.response?.data;
  if (errorData && errorData instanceof Blob) {
    errorData
      ?.text()
      .then((r: string) => {
        return JSON.parse(r).data;
      })
      .then((r: IBadRequestValidationFailedModel) => {
        const validationFailures = r.validationFailures?.map((v: any) => v.errorMessage);
        return validationFailures?.join("\r\n");
      });
  } else if (errorData) {
    if (errorData.validationFailures && errorData.validationFailures.length > 0) {
      const validationFailures = errorData.validationFailures.map((v) => v.errorMessage);
      return validationFailures.join("\r\n");
    } else {
      return errorData.errorMessage;
    }
  } else return errorResponse.message;
};

const messageBar = (text: string, type: MessageBarType): React.JSX.Element => {
  return (
    <MessageBar messageBarType={type} isMultiline={true} dismissButtonAriaLabel="Close">
      {text}
    </MessageBar>
  );
};

export const toErrorMessageBar = (errorMessage: string): React.JSX.Element => {
  return messageBar(errorMessage, MessageBarType.error);
};

export const toSuccessMessageBar = (successMessage: string): React.JSX.Element => {
  return messageBar(successMessage, MessageBarType.success);
};
